"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseLocalizations = void 0;
var _constants = require("../constants");
var parseLocalizations = exports.parseLocalizations = function parseLocalizations(localizations) {
    return {
        update: localizations.update ? localizations.update : _constants.defaultTranslations.update,
        updateYourBrowser: localizations.updateYourBrowser ? localizations.updateYourBrowser : _constants.defaultTranslations.updateYourBrowser,
        yourBrowserIsOutdated: localizations.yourBrowserIsOutdated ? localizations.yourBrowserIsOutdated : _constants.defaultTranslations.yourBrowserIsOutdated
    };
}; //# sourceMappingURL=parseLocalizations.js.map
